<template>
	<div >
		<div class="w">
			<!-- header -->
			<SecondHead activeIndex="6" textColor="#333" color="#333"></SecondHead>
		</div>
		<div style="padding-bottom: 30px; padding-top: 2px;border-top: 2px solid #f5f5f5;">
			<div class="management">
				<div class="sidebar" >
					<div class="sidebartitle" @click="setQuestionnaireType(1)" v-show="permissionList.admin1026">
						<div class="pitchOnTrue" v-if="questionnaireType == 1"><img src="../assets/grid_icon_sel2.png" alt="" class="btn-img" /></div>
						<div class="pitchOnfalse" v-else><img src="../assets/grid_icon_sel3.png" alt="" class="btn-img" /></div>
						<span :class="questionnaireType == 1 ? 'btnTitleClick' : 'btnTitle'">{{$t('QuesLibrary.QuestionnaireType')}}</span>
					</div>
					<div class="sidebartitle" @click="setQuestionnaireType(2)" v-show="permissionList.admin1027">
						<div class="pitchOnTrue" v-if="questionnaireType == 2"><img src="../assets/list_icon_def2.png" alt="" class="btn-img" /></div>
						<div class="pitchOnfalse" v-else><img src="../assets/list_icon_def3.png" alt="" class="btn-img" /></div>
						<span class="btnTitle" :class="questionnaireType == 2 ? 'btnTitleClick' : 'btnTitle'">{{$t('QuesLibrary.TemplatSistem')}}</span>
					</div>
					<div class="sidebartitle" @click="setQuestionnaireType(3)" v-show="permissionList.admin1028">
						<div class="pitchOnTrue" v-if="questionnaireType == 3"><img src="../assets/Mytemplate4.png" alt="" class="btn-img" /></div>
						<div class="pitchOnfalse" v-else><img src="../assets/Mytemplate3.png" alt="" class="btn-img" /></div>
						<span class="btnTitle" :class="questionnaireType == 3 ? 'btnTitleClick' : 'btnTitle'">{{$t('QuesLibrary.TemplatSaya')}}</span>
					</div>
					<div class="sidebartitle" @click="setQuestionnaireType(4)" v-show="permissionList.admin1029">
						<div class="pitchOnTrue" v-if="questionnaireType == 4"><img src="../assets/Myquestionbank4.png" alt="" class="btn-img" /></div>
						<div class="pitchOnfalse" v-else><img src="../assets/Myquestionbank3.png" alt="" class="btn-img" /></div>
						<span class="btnTitle" :class="questionnaireType == 4 ? 'btnTitleClick' : 'btnTitle'">{{$t('QuesLibrary.BankSoalanSaya')}}</span>
					</div>
					<div class="sidebartitle" @click="setQuestionnaireType(5)" v-show="permissionList.admin1030">
						<div class="pitchOnTrue" v-if="questionnaireType == 5"><img src="../assets/Systemquestionbank.png" alt="" class="btn-img" /></div>
						<div class="pitchOnfalse" v-else><img src="../assets/Systemquestionbank2.png" alt="" class="btn-img" /></div>
						<span class="btnTitle" :class="questionnaireType == 5 ? 'btnTitleClick' : 'btnTitle'">{{$t('QuesLibrary.BankSoalanSistem')}}</span>
					</div>
					<div class="sidebartitle" @click="setQuestionnaireType(6)" v-show="permissionList.admin1031">
						<div class="pitchOnTrue" v-if="questionnaireType == 6"><img src="../assets/Questionbankanalysis.png" alt="" class="btn-img" /></div>
						<div class="pitchOnfalse" v-else><img src="../assets/Questionbankanalysis2.png" alt="" class="btn-img" /></div>
						<span class="btnTitle" :class="questionnaireType == 6 ? 'btnTitleClick' : 'btnTitle'">{{$t('QuesLibrary.QuestionBankAnalysis')}}</span>
					</div>

					<div class="sidebartitle" @click="setQuestionnaireType(7)" v-show="permissionList.admin1032">
						<div class="pitchOnTrue" v-if="questionnaireType == 7"><img src="../assets/Problemlabel3.png" alt="" class="btn-img" /></div>
						<div class="pitchOnfalse" v-else><img src="../assets/Problemlabel.png" alt="" class="btn-img" /></div>
						<span class="btnTitle" :class="questionnaireType == 7 ? 'btnTitleClick' : 'btnTitle'">{{$t('QuesLibrary.LabelMasalah')}}</span>
					</div>
					<div class="sidebartitle" @click="setQuestionnaireType(8)">
						<div class="pitchOnTrue" v-if="questionnaireType == 8"><img src="../assets/tx/tab_sel_icon5.png" alt="" class="btn-img" /></div>
						<div class="pitchOnfalse" v-else><img src="../assets/tx/tab_def_icon5.png" alt="" class="btn-img" /></div>
						<span 
							class="btnTitle" 
							:class="questionnaireType == 8 ? 'btnTitleClick' : 'btnTitle'"
							:style="{fontSize: lang != 'zh-CN' ? '12px' : '14px'}"
						>
							{{$t('QuesLibrary.PengurusanMasalah')}}
						</span>
					</div>
				</div>
				<router-view class="box" v-if="$route.path == '/addQuestionBankWJ'"></router-view>
				<div v-else class="managementList">
					<addClassification v-if="questionnaireType == 1 && permissionList.admin1026"></addClassification>
					<addQuestionnaire v-if="questionnaireType == 2 && permissionList.admin1027"></addQuestionnaire>
					<myaddQuestionnaire v-if="questionnaireType == 3 && permissionList.admin1028"></myaddQuestionnaire>
					<myQuestionBank v-if="questionnaireType == 4 && permissionList.admin1029"></myQuestionBank>
					<systemQuestionBank v-if="questionnaireType == 5 && permissionList.admin1030"></systemQuestionBank>
					<questionBankAnalysis v-if="questionnaireType == 6 && permissionList.admin1031"></questionBankAnalysis>
					<labelManagement v-if="questionnaireType == 7 && permissionList.admin1032"></labelManagement>
					<testQuestionManagement v-if="questionnaireType == 8 "></testQuestionManagement>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SecondHead from '@/components/SecondHead';
import addClassification from '@/page/management/addClassification';
import addQuestionnaire from '@/page/management/addQuestionnaire';
import myaddQuestionnaire from '@/page/management/myaddQuestionnaire';
import systemQuestionBank from '@/page/management/systemQuestionBank';
import myQuestionBank from '@/page/management/myQuestionBank';
import labelManagement from '@/page/management/labelManagement';
import questionBankAnalysis from '@/page/management/questionBankAnalysis';
import testQuestionManagement from '@/page/management/testQuestionManagement';
export default {
	name: 'managementIndex',
	components: {
		SecondHead,
		addClassification,
		addQuestionnaire,
		myaddQuestionnaire,
		myQuestionBank,
		labelManagement,
		systemQuestionBank,
		questionBankAnalysis,
		testQuestionManagement
	},
	computed:{
		lang()  {
			return localStorage.getItem('lang')
		}
	},
	data() {
		return {
			permissionList: {},
			questionnaireType: 1,
			height: 0,
			rightheight: 0
		};
	},
	created() {
		this.questionnaireType = this.$route.query.back || this.$route.query.index || 1
		this.accessPermission();
		console.log('this.permissionList :>> ', this.permissionList.admin1026);
	},
	mounted() {
		var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
		this.height = winHeight - 108;
		this.rightheight = winHeight - 60;
		window.onresize = () => {
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60;
		};
	},
	methods: {
		setQuestionnaireType(index) {
			this.questionnaireType = index;
			if (this.$route.path != 'managementIndex') {
				this.$router.replace({
					path: '/managementIndex',
					query: {
						back: index,
					}
				})
			}
		},
		accessPermission() {
			let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			// console.log(userInfo.permissionList);
			let arr = userInfo.permissionList;
			let permissionList = {};
			arr.forEach((item, index) => {
				permissionList['admin' + item] = item;
			});
			console.log(permissionList);
			this.permissionList = permissionList;

			if (!this.$route.query.back && !this.$route.query.index) {
				if (permissionList.admin1026) {
					this.questionnaireType = 1;
				} else if (permissionList.admin1027) {
					this.questionnaireType = 2;
				} else if (permissionList.admin1028) {
					this.questionnaireType = 3;
				} else if (permissionList.admin1029) {
					this.questionnaireType = 4;
				} else if (permissionList.admin1030) {
					this.questionnaireType = 5;
				} else if (permissionList.admin1031) {
					this.questionnaireType = 6;
				} else if (permissionList.admin1032) {
					this.questionnaireType = 7;
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.box {
	background-color: #fff;
	width: 100%;
	min-width: 1030px;
}
.management {
	// width: 1200px;
	// margin: 0px auto;
	// padding: 24px;
	display: flex;
	min-height: 500px;
	// justify-content: space-between;
	background-color: #ffffff;
	.sidebar {
		min-width: 80px;
		max-width: 80px;
		text-align: center;
		border-right: 1px solid #f5f5f5;
		box-sizing: border-box;
		// padding: 20px 10px 20px 10px;
		.sidebartitle {
			// border: 1px solid #cccccc;
			// margin-bottom: 10px;
			color: #000000;
			padding: 10px 0;
			cursor: pointer;
			text-align: center;

			.pitchOnTrue {
				margin: 0px auto;
				width: 50px;
				height: 50px;
				border-radius: 5px;
				background-color: #0080ff;
			}
			.pitchOnfalse {
				margin: 0px auto;
				width: 50px;
				height: 50px;
				border-radius: 5px;
			}
			.btn-img {
				margin-top: 10px;
			}
			.btnTitle {
				display: block;
				// margin-top: 20px;
				font-size: 14px;
			}
			.btnTitleClick {
				display: block;
				// margin-top: 20px;
				color: #0080ff;
				font-size: 14px;
			}
		}
	}
	.managementList {
		width: calc(100% - 80px);
		background-color: #ffffff;
	}
}
</style>
